import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const SubsectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SubsectionLabel = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${colorTokens.text.medium};
`;

export const SubsectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SubsectionKbLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colorTokens.text.medium};
  text-decoration: none;
`;
